module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAHpJREFUOE/dU9sNgCAQa7fQpXQMGUnH0KVkixoSSC4GCAZ/lM97lF57RxSepAnAFtMLySNXygrACWCIeU9yfAog20Ay+1mNwVcAjNpJsJKu97gHsFCSVbu1OdX5VwBmAKvxvJVFGMH9wcbKLXRvYvcxJXcCSUdyz7G9AHOVSHAac5kVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher-task/add.png
// module id = k20J
// module chunks = 1